const carNumber = {
    methods: {
      carNumberMask (carNumber) {
        let carNumberMask = ``;
        if (!carNumber) return carNumber
        
        let carNumberLen = carNumber.length; // 11소1111, 제주60바1234
        
        switch(carNumberLen) {
            case 7 :
                carNumberMask += carNumber.substr(0, 4);
                break;
            case 9 : 
                carNumberMask += carNumber.substr(0, 6);
                break;
        }

        carNumberMask += `***`;

        return carNumberMask;
      }
    }
}

export default carNumber
  